import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { gray } from 'bold-ui/lib/styles/colors'
import React from 'react'

import { ConselhoClasseImpressao } from './model'

export interface PrintSignProps {
  nomeProfissional?: string
  cboProfissional?: string
  conselhoClasse?: ConselhoClasseImpressao
}

export const PrintSign = (props: PrintSignProps) => {
  const { nomeProfissional, cboProfissional, conselhoClasse } = props
  return (
    <View style={classes.container}>
      <View style={classes.sign} />
      <Text style={classes.signText}> {nomeProfissional}</Text>
      {cboProfissional && <Text style={classes.signText}> {cboProfissional}</Text>}
      {conselhoClasse?.numero && (
        <Text style={classes.signText}>
          {conselhoClasse.sigla}-{conselhoClasse.uf.sigla} {conselhoClasse.numero}
        </Text>
      )}
    </View>
  )
}

const classes = StyleSheet.create({
  container: {
    width: 400,
    alignSelf: 'center',
    marginTop: 38,
    paddingTop: 2,
    lineHeight: 1.25,
  },
  sign: {
    width: 250,
    alignSelf: 'center',
    borderTopWidth: 1,
    borderTopColor: gray.c30,
  },
  signText: {
    fontFamily: 'Times-Roman',
    fontSize: 9,
    textAlign: 'center',
  },
})
